<template>
  <div class="wrapper" id="pricing-wrapper">
    <div class="card" v-if="!wasSent">
      <h2>Contact</h2>
      <p>
        Kaado is a young product and growing every day. We appreciate your
        feedback - our development team reads every message!
      </p>
      <textarea
        name="message"
        class="card-content"
        placeholder="Your message, question or feedback"
        v-model="message"
        id=""
        cols="30"
        rows="10"
      ></textarea>
      <input class="input"
        type="email"
        v-model="email"
        placeholder="Your Email"
        v-if="sendMail"
      />
      <br />
      <input class="input" type="checkbox" name="sendMail" id="sendMail" v-model="sendMail" />
      <label for="sendMail"
        >Attach my email address to the message so the Kaado team can get back
        to me.</label
      >
      <br />
      <br />
      <button class="button button-primary button-right" @click="send">
        Send
      </button>
    </div>
    <h2 v-else>Thanks a lot!</h2>
  </div>
</template>

<script>
import { supabase } from "../supabase";
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"

export default {
  data() {
    return {
      email: "",
      message: "",
      sendMail: "",
      wasSent: false,
    };
  },
  methods: {
    async send() {
      try {
        let dbObj = {
          email: "",
          message: this.message,
        };
        if (this.sendMail) {
          dbObj.email = this.email;
        }
        const { data, error } = await supabase
          .from("feedback")
          .insert(dbObj, { returning: "minimal" });
        if (error) {
          throw error;
        } else {
          this.wasSent = true;
        }
      } catch (error) {
        
           Toastify({
          text: "Sending your message failed. Please try again. \n" + error.error_description || error.message || error,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top", // `top` or `bottom`
          position: "center", // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          style: {
            background: "var(--primary-500)",
          },
          onClick: function () { } // Callback after click
        }).showToast();
      }
    },
  },
  mounted: function () {
    if (supabase.auth.currentUser) {
      this.email = supabase.auth.currentUser.email;
    }
  },
};
</script>